import { AxiosResponse } from "axios";
import { AXIOS } from "../config/axios.config";
import { IReviewCategory, IReviewsList } from "../types/global";

class ReviewService {
  async fetchReviews(query: {}): Promise<
    AxiosResponse<{ data: IReviewsList[] }>
  > {
    return await AXIOS.get(`/review/getAll${query}`);
  }
  fetchCategories(): Promise<AxiosResponse<{ data: IReviewCategory[] }>> {
    return AXIOS.get("/reviewCategory/getAll");
  }
}
export default new ReviewService();
